import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-produit',
  templateUrl: './produit.component.html',
  styleUrls: ['./produit.component.scss']
})
export class ProduitComponent implements OnInit {
  instance: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.instance = this.route.snapshot.data.produit;
    if (
      !this.instance ||
      !this.instance.id_instance ||
      this.instance.id_instance === 0 ||
      ((!this.instance.id_si_planning || this.instance.id_si_planning === 0) &&
        (!this.instance.id_si_forfait || this.instance.id_si_forfait === 0) &&
        (!this.instance.id_si_b2b || this.instance.id_si_b2b === 0)
      )
    ) {
      this.redirectToNotFound();
    }
  }

  redirectToNotFound() {
    this.router.navigate(['/page-introuvable']);
  }
}
